export function Footer() {
  return (
    <footer className="border-t border-gray-200 dark:border-gray-800">
      <div className="mx-auto max-w-6xl px-4 py-8 text-center text-sm text-gray-500 dark:text-gray-400 sm:px-6">
        <p>Built with React, Vite, TypeScript, and Tailwind CSS.</p>
      </div>
    </footer>
  );
}
